import { Float32BufferAttribute } from "three"
import { Utils } from "/src/scripts/utils"

export { ChapterPositions }

class ChapterPositions extends Float32BufferAttribute {
    #id

    static #defaultPositions(count) {
        return new Float32Array(count * 3)
            .map(() => Utils.basicRandomValue() * 8)
    }

    // #PositionsChapter1() {
    //     const geo = new BoxGeometry(5, 5, 5, 8.5, 8.5, 8.5)

    //     geo.rotateY(Math.PI * .45)
    //     geo.rotateX(Math.PI * .125)

    //     return geo.getAttribute("position").array
    // }

    #selectChapter(id) {
        // eslint-disable-next-line sonarjs/no-small-switch
        switch (id) {
            // case 1: return this.#PositionsChapter1
            default: return ChapterPositions.#defaultPositions
        }
    }

    constructor(count) {
        super(ChapterPositions.#defaultPositions(count), 3)
    }

    getVertexPositionsForChapter(count, id = null) {
        const chapterBuilder = this.#selectChapter(id)

        if (this.#id != id && chapterBuilder) {
            this.#id = id
            this.set(chapterBuilder(count))
        }

        return this
    }
}